import { TrendDirection } from 'app/lib/constants';

export const translation = {
    title: 'Usage',
    emptyData: {
        title: 'No Data',
        description: 'Query returned no data.'
    },
    warehouseSpend: {
        title: 'Warehouse Spend',
        totalSpend: 'TOTAL WAREHOUSE SPEND',
        inspector: {
            selectWarehouse: 'Select a warehouse to see details.',
            permissionDenied: 'Warehouse details unavailable due to permissions.',
            moreThan1WarehouseSelected: 'Warehouse details unavailable when more than 1 is selected',
            fields: {
                name: 'Name',
                size: 'Size',
                comment: 'Comment',
                owner: 'Owner',
                is_default: 'Default',
                auto_suspend: 'Auto Suspend',
                auto_resume: 'Auto Resume',
                created_on: 'Created',
                updated_on: 'Updated'
            }
        },
        warehouseUsage: {
            fields: {
                primaryDimension: 'Primary Dimension',
                secondaryDimension: 'Secondary Dimension',
                selectedMeasure: 'Measure',
                dateBin: 'Date Bin'
            },
            showLineChart: 'Show Line Chart',
            showBarChart: 'Show Bar Chart',
            measures: {
                'QUERY COUNT': 'Query Count',
                'QUERY TIME': 'Query Time',
                'CLOUD SERVICES CREDITS': 'Cloud Services Credits',
                'COMPUTE CREDITS': 'Compute Credits'
            },
            dimensions: {
                DATE: 'Date',
                USER: 'User',
                WAREHOUSE: 'Warehouse'
            }
        },
        tabs: {
            queryDetails_one: 'Query Details',
            queryDetails_other: 'Query Details {{count}}',
            newQuery: 'New Query…',
            warehouseUsage: 'Warehouse Usage',
            warehouseUsage_disabled: 'No Warehouse Usage Job is configured',
            spendOverview: 'Spend Overview'
        },
        spendOverview: {
            trendColumn: {
                description: 'Trend values are calculated based on the last 2 months.'
            },
            empty: {
                title: 'Preview Unavailable',
                description: 'Select a Warehouse to see a preview.'
            },
            trendDirection: {
                [TrendDirection.UP]: 'up',
                [TrendDirection.NEUTRAL]: 'neutral',
                [TrendDirection.DOWN]: 'down',
                [TrendDirection.NOT_APPLICABLE]: 'N/A'
            },
            trendDiffPercentage: {
                notApplicable: '(+/- N/A)',
                percentage: `({{percentage}}%)`
            }
        },
        appliedFilters: 'Applied filters:'
    },
    admin: {
        title: 'Admin'
    },
    ROIReport: {
        title: 'ROI Report',
        tabs: {
            ROIOverview: 'ROI Overview',
            assetROI: 'Asset ROI'
        },
        noAssetsFound: 'No assets found.',
        noAccessInfo: 'Table ROI job is not enabled or you have no access to EVENTS table.',
        inspector: {
            totalTimeSpentWriting: 'Total Time Spent Writing',
            totalRectordsWritten: 'Total Records Written',
            totalQueriesExecuted: 'Total Queries Executed',
            totalTimeSpentQuerying: 'Total Time spent Querying',
            showSelectedAssetROI: 'Show Selected Asset ROI'
        },
        chartTitle: {
            AVG_QUERY_COUNT: '$t(common:frequency.{{bin}}) Query Trends',
            AVG_QUERY_TIME: 'Client Query Timing',
            AVG_RUNTIME: '$t(common:frequency.{{bin}}) Update Time',
            AVG_RECORDS_WRITTEN: '$t(common:frequency.{{bin}}) Update Records'
        },
        measures: {
            QUERY_COUNT: 'Query/Statement Count',
            QUERY_TIME: 'Query/Statement Time',
            RECORDS_WRITTEN: 'Records Written'
        },
        dimensions: {
            DATE: 'Date',
            ACCESS_TYPE: 'Access Type',
            TABLE: 'Table',
            USER: 'User',
            WAREHOUSE: 'Warehouse'
        }
    }
};
